import type { UserRole } from './types'
import type { User } from '@/api/users/types'

export const hasRole = (user: User | null | undefined, role: UserRole['name']) =>
  user?.roles?.some((entry) => entry.name === role) ?? false

export const getAuthRoleFlags = (user: User | null | undefined) => ({
  isAdmin: hasRole(user, 'admin'),
  isOwner: hasRole(user, 'owner'),
  isManager: hasRole(user, 'manager'),
  isUser: hasRole(user, 'user'),
  isPostCreator: hasRole(user, 'post-creator')
})
